/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DeadDrop
 * Agent coordination service with MCP and REST interfaces
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateTopicRequest,
  FlushTopicResponse,
  HTTPValidationError,
  ListTopicMessagesResponse,
  ListTopicMessagesV1TopicsTopicIdMessagesGetParams,
  ListTopicsResponse,
  ListTopicsV1TopicsGetParams,
  TopicResponse,
  UpdateTopicRequest
} from '../model';

import { apiMutator } from '../../../lib/api-mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * List all topics owned by authenticated user with pagination.
 *
 * Authentication via Bearer token. Returns only topics owned by user.
 * Includes connection and message counts for each topic, plus full connection
 * details with health metrics for frontend cache pre-population.
 *
 * Args:
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user from Clerk
 *     page: Page number (0-indexed)
 *     page_size: Items per page (max 100)
 *
 * Returns:
 *     Paginated list of user's topics with counts and embedded connection data
 * @summary List Topics
 */
export const listTopicsV1TopicsGet = (
    params?: ListTopicsV1TopicsGetParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<ListTopicsResponse>(
      {url: `/v1/topics`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListTopicsV1TopicsGetQueryKey = (params?: ListTopicsV1TopicsGetParams,) => {
    return [
    `/v1/topics`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTopicsV1TopicsGetQueryOptions = <TData = Awaited<ReturnType<typeof listTopicsV1TopicsGet>>, TError = HTTPValidationError>(params?: ListTopicsV1TopicsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTopicsV1TopicsGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTopicsV1TopicsGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTopicsV1TopicsGet>>> = ({ signal }) => listTopicsV1TopicsGet(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTopicsV1TopicsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTopicsV1TopicsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listTopicsV1TopicsGet>>>
export type ListTopicsV1TopicsGetQueryError = HTTPValidationError


export function useListTopicsV1TopicsGet<TData = Awaited<ReturnType<typeof listTopicsV1TopicsGet>>, TError = HTTPValidationError>(
 params: undefined |  ListTopicsV1TopicsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTopicsV1TopicsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTopicsV1TopicsGet>>,
          TError,
          Awaited<ReturnType<typeof listTopicsV1TopicsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTopicsV1TopicsGet<TData = Awaited<ReturnType<typeof listTopicsV1TopicsGet>>, TError = HTTPValidationError>(
 params?: ListTopicsV1TopicsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTopicsV1TopicsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTopicsV1TopicsGet>>,
          TError,
          Awaited<ReturnType<typeof listTopicsV1TopicsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTopicsV1TopicsGet<TData = Awaited<ReturnType<typeof listTopicsV1TopicsGet>>, TError = HTTPValidationError>(
 params?: ListTopicsV1TopicsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTopicsV1TopicsGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Topics
 */

export function useListTopicsV1TopicsGet<TData = Awaited<ReturnType<typeof listTopicsV1TopicsGet>>, TError = HTTPValidationError>(
 params?: ListTopicsV1TopicsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTopicsV1TopicsGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTopicsV1TopicsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Create new topic for message coordination.
 *
 * Authentication via Bearer token. Authenticated user becomes topic owner.
 *
 * Args:
 *     req_obj: Topic creation request with name and optional description
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user from Clerk
 *
 * Returns:
 *     Created topic details
 *
 * Raises:
 *     TopicLimitReachedError: 403 if topic limit reached
 *     TopicNameConflictError: 409 if topic name already exists
 * @summary Create Topic
 */
export const createTopicV1TopicsPost = (
    createTopicRequest: CreateTopicRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<TopicResponse>(
      {url: `/v1/topics`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTopicRequest, signal
    },
      options);
    }




export const getCreateTopicV1TopicsPostMutationKey = () => ['createTopicV1TopicsPost'] as const;

export const getCreateTopicV1TopicsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTopicV1TopicsPost>>, TError,CreateTopicV1TopicsPostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof createTopicV1TopicsPost>>, TError,CreateTopicV1TopicsPostMutationVariables, TContext> => {

const mutationKey = getCreateTopicV1TopicsPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTopicV1TopicsPost>>, CreateTopicV1TopicsPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createTopicV1TopicsPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTopicV1TopicsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createTopicV1TopicsPost>>>
    export type CreateTopicV1TopicsPostMutationBody = CreateTopicRequest
    export type CreateTopicV1TopicsPostMutationError = HTTPValidationError
    export type CreateTopicV1TopicsPostMutationVariables = {data: CreateTopicRequest}

    /**
 * @summary Create Topic
 */
export const useCreateTopicV1TopicsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTopicV1TopicsPost>>, TError,CreateTopicV1TopicsPostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTopicV1TopicsPost>>,
        TError,
        CreateTopicV1TopicsPostMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTopicV1TopicsPostMutationOptions(options), queryClient);
    }
    /**
 * Delete topic and all associated messages (cascade delete).
 *
 * Authentication via Bearer token. Only topic owner can delete.
 *
 * Args:
 *     topic_id: Topic database ID
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user from Clerk
 *
 * Raises:
 *     TopicNotFoundError: 404 if topic not found
 *     TopicAccessDeniedError: 403 if user not topic owner
 * @summary Delete Topic
 */
export const deleteTopicV1TopicsTopicIdDelete = (
    topicId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/v1/topics/${topicId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteTopicV1TopicsTopicIdDeleteMutationKey = () => ['deleteTopicV1TopicsTopicIdDelete'] as const;

export const getDeleteTopicV1TopicsTopicIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTopicV1TopicsTopicIdDelete>>, TError,DeleteTopicV1TopicsTopicIdDeleteMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTopicV1TopicsTopicIdDelete>>, TError,DeleteTopicV1TopicsTopicIdDeleteMutationVariables, TContext> => {

const mutationKey = getDeleteTopicV1TopicsTopicIdDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTopicV1TopicsTopicIdDelete>>, DeleteTopicV1TopicsTopicIdDeleteMutationVariables> = (props) => {
          const {topicId} = props ?? {};

          return  deleteTopicV1TopicsTopicIdDelete(topicId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTopicV1TopicsTopicIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTopicV1TopicsTopicIdDelete>>>

    export type DeleteTopicV1TopicsTopicIdDeleteMutationError = HTTPValidationError
    export type DeleteTopicV1TopicsTopicIdDeleteMutationVariables = {topicId: string}

    /**
 * @summary Delete Topic
 */
export const useDeleteTopicV1TopicsTopicIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTopicV1TopicsTopicIdDelete>>, TError,DeleteTopicV1TopicsTopicIdDeleteMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTopicV1TopicsTopicIdDelete>>,
        TError,
        DeleteTopicV1TopicsTopicIdDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteTopicV1TopicsTopicIdDeleteMutationOptions(options), queryClient);
    }
    /**
 * Retrieve topic details by ID.
 *
 * Authentication via Bearer token. Only topic owner can access.
 *
 * Args:
 *     topic_id: Topic database ID
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user from Clerk
 *
 * Returns:
 *     Topic details with connection and message counts, plus embedded connections
 *
 * Raises:
 *     TopicNotFoundError: 404 if topic not found
 *     TopicAccessDeniedError: 403 if topic not owned by user
 * @summary Get Topic By Id
 */
export const getTopicByIdV1TopicsTopicIdGet = (
    topicId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<TopicResponse>(
      {url: `/v1/topics/${topicId}`, method: 'GET', signal
    },
      options);
    }




export const getGetTopicByIdV1TopicsTopicIdGetQueryKey = (topicId: string,) => {
    return [
    `/v1/topics/${topicId}`
    ] as const;
    }


export const getGetTopicByIdV1TopicsTopicIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getTopicByIdV1TopicsTopicIdGet>>, TError = HTTPValidationError>(topicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopicByIdV1TopicsTopicIdGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTopicByIdV1TopicsTopicIdGetQueryKey(topicId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTopicByIdV1TopicsTopicIdGet>>> = ({ signal }) => getTopicByIdV1TopicsTopicIdGet(topicId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: topicId !== null && topicId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTopicByIdV1TopicsTopicIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTopicByIdV1TopicsTopicIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getTopicByIdV1TopicsTopicIdGet>>>
export type GetTopicByIdV1TopicsTopicIdGetQueryError = HTTPValidationError


export function useGetTopicByIdV1TopicsTopicIdGet<TData = Awaited<ReturnType<typeof getTopicByIdV1TopicsTopicIdGet>>, TError = HTTPValidationError>(
 topicId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopicByIdV1TopicsTopicIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopicByIdV1TopicsTopicIdGet>>,
          TError,
          Awaited<ReturnType<typeof getTopicByIdV1TopicsTopicIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTopicByIdV1TopicsTopicIdGet<TData = Awaited<ReturnType<typeof getTopicByIdV1TopicsTopicIdGet>>, TError = HTTPValidationError>(
 topicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopicByIdV1TopicsTopicIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopicByIdV1TopicsTopicIdGet>>,
          TError,
          Awaited<ReturnType<typeof getTopicByIdV1TopicsTopicIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTopicByIdV1TopicsTopicIdGet<TData = Awaited<ReturnType<typeof getTopicByIdV1TopicsTopicIdGet>>, TError = HTTPValidationError>(
 topicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopicByIdV1TopicsTopicIdGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Topic By Id
 */

export function useGetTopicByIdV1TopicsTopicIdGet<TData = Awaited<ReturnType<typeof getTopicByIdV1TopicsTopicIdGet>>, TError = HTTPValidationError>(
 topicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTopicByIdV1TopicsTopicIdGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTopicByIdV1TopicsTopicIdGetQueryOptions(topicId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Update topic metadata (name and/or description).
 *
 * Authentication via Bearer token. Only topic owner can update.
 *
 * Args:
 *     topic_id: Topic database ID
 *     request_obj: Update request with optional name and description
 *     request: FastAPI Request object for rate limiting
 *     response: FastAPI Response object for rate limiting
 *     current_user: Authenticated user from Clerk
 *
 * Returns:
 *     Updated topic details
 *
 * Raises:
 *     TopicNotFoundError: 404 if topic not found
 *     TopicAccessDeniedError: 403 if user not topic owner
 *     TopicNameConflictError: 409 if new name conflicts with existing topic
 * @summary Update Topic
 */
export const updateTopicV1TopicsTopicIdPatch = (
    topicId: string,
    updateTopicRequest: UpdateTopicRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<TopicResponse>(
      {url: `/v1/topics/${topicId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateTopicRequest, signal
    },
      options);
    }




export const getUpdateTopicV1TopicsTopicIdPatchMutationKey = () => ['updateTopicV1TopicsTopicIdPatch'] as const;

export const getUpdateTopicV1TopicsTopicIdPatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTopicV1TopicsTopicIdPatch>>, TError,UpdateTopicV1TopicsTopicIdPatchMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTopicV1TopicsTopicIdPatch>>, TError,UpdateTopicV1TopicsTopicIdPatchMutationVariables, TContext> => {

const mutationKey = getUpdateTopicV1TopicsTopicIdPatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTopicV1TopicsTopicIdPatch>>, UpdateTopicV1TopicsTopicIdPatchMutationVariables> = (props) => {
          const {topicId,data} = props ?? {};

          return  updateTopicV1TopicsTopicIdPatch(topicId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTopicV1TopicsTopicIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateTopicV1TopicsTopicIdPatch>>>
    export type UpdateTopicV1TopicsTopicIdPatchMutationBody = UpdateTopicRequest
    export type UpdateTopicV1TopicsTopicIdPatchMutationError = HTTPValidationError
    export type UpdateTopicV1TopicsTopicIdPatchMutationVariables = {topicId: string;data: UpdateTopicRequest}

    /**
 * @summary Update Topic
 */
export const useUpdateTopicV1TopicsTopicIdPatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTopicV1TopicsTopicIdPatch>>, TError,UpdateTopicV1TopicsTopicIdPatchMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTopicV1TopicsTopicIdPatch>>,
        TError,
        UpdateTopicV1TopicsTopicIdPatchMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateTopicV1TopicsTopicIdPatchMutationOptions(options), queryClient);
    }
    /**
 * Flush topic by deleting all messages and resetting sequence counters.
 *
 * This endpoint:
 * - Deletes all messages in the topic
 * - Resets TopicSequenceCounter.current_value to 0
 * - Resets Connection.last_processed_sequence to 0 for all connections
 * - Preserves topic metadata, connection metadata, and health metrics
 * - Notifies topic owner via WebSocket if connected
 *
 * Authentication via Bearer token. Only topic owner can flush.
 *
 * Args:
 *     topic_id: Topic database ID
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user from Clerk
 *
 * Returns:
 *     Flush operation summary with counts
 *
 * Raises:
 *     TopicNotFoundError: 404 if topic not found
 *     TopicAccessDeniedError: 403 if user not topic owner
 * @summary Flush Topic
 */
export const flushTopicV1TopicsTopicIdFlushPost = (
    topicId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<FlushTopicResponse>(
      {url: `/v1/topics/${topicId}/flush`, method: 'POST', signal
    },
      options);
    }




export const getFlushTopicV1TopicsTopicIdFlushPostMutationKey = () => ['flushTopicV1TopicsTopicIdFlushPost'] as const;

export const getFlushTopicV1TopicsTopicIdFlushPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof flushTopicV1TopicsTopicIdFlushPost>>, TError,FlushTopicV1TopicsTopicIdFlushPostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof flushTopicV1TopicsTopicIdFlushPost>>, TError,FlushTopicV1TopicsTopicIdFlushPostMutationVariables, TContext> => {

const mutationKey = getFlushTopicV1TopicsTopicIdFlushPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof flushTopicV1TopicsTopicIdFlushPost>>, FlushTopicV1TopicsTopicIdFlushPostMutationVariables> = (props) => {
          const {topicId} = props ?? {};

          return  flushTopicV1TopicsTopicIdFlushPost(topicId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FlushTopicV1TopicsTopicIdFlushPostMutationResult = NonNullable<Awaited<ReturnType<typeof flushTopicV1TopicsTopicIdFlushPost>>>

    export type FlushTopicV1TopicsTopicIdFlushPostMutationError = HTTPValidationError
    export type FlushTopicV1TopicsTopicIdFlushPostMutationVariables = {topicId: string}

    /**
 * @summary Flush Topic
 */
export const useFlushTopicV1TopicsTopicIdFlushPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof flushTopicV1TopicsTopicIdFlushPost>>, TError,FlushTopicV1TopicsTopicIdFlushPostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof flushTopicV1TopicsTopicIdFlushPost>>,
        TError,
        FlushTopicV1TopicsTopicIdFlushPostMutationVariables,
        TContext
      > => {
      return useMutation(getFlushTopicV1TopicsTopicIdFlushPostMutationOptions(options), queryClient);
    }
    /**
 * List messages in a topic with pagination.
 *
 * Authentication via Bearer token. Only topic owner can access.
 *
 * Args:
 *     topic_id: Topic database ID
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user from Clerk
 *     page: Page number (0-indexed)
 *     page_size: Items per page (max 100)
 *
 * Returns:
 *     Paginated list of messages in topic
 *
 * Raises:
 *     TopicNotFoundError: 404 if topic not found
 *     TopicAccessDeniedError: 403 if topic not owned by user
 * @summary List Topic Messages
 */
export const listTopicMessagesV1TopicsTopicIdMessagesGet = (
    topicId: string,
    params?: ListTopicMessagesV1TopicsTopicIdMessagesGetParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<ListTopicMessagesResponse>(
      {url: `/v1/topics/${topicId}/messages`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListTopicMessagesV1TopicsTopicIdMessagesGetQueryKey = (topicId: string,
    params?: ListTopicMessagesV1TopicsTopicIdMessagesGetParams,) => {
    return [
    `/v1/topics/${topicId}/messages`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTopicMessagesV1TopicsTopicIdMessagesGetQueryOptions = <TData = Awaited<ReturnType<typeof listTopicMessagesV1TopicsTopicIdMessagesGet>>, TError = HTTPValidationError>(topicId: string,
    params?: ListTopicMessagesV1TopicsTopicIdMessagesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTopicMessagesV1TopicsTopicIdMessagesGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTopicMessagesV1TopicsTopicIdMessagesGetQueryKey(topicId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTopicMessagesV1TopicsTopicIdMessagesGet>>> = ({ signal }) => listTopicMessagesV1TopicsTopicIdMessagesGet(topicId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: topicId !== null && topicId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTopicMessagesV1TopicsTopicIdMessagesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTopicMessagesV1TopicsTopicIdMessagesGetQueryResult = NonNullable<Awaited<ReturnType<typeof listTopicMessagesV1TopicsTopicIdMessagesGet>>>
export type ListTopicMessagesV1TopicsTopicIdMessagesGetQueryError = HTTPValidationError


export function useListTopicMessagesV1TopicsTopicIdMessagesGet<TData = Awaited<ReturnType<typeof listTopicMessagesV1TopicsTopicIdMessagesGet>>, TError = HTTPValidationError>(
 topicId: string,
    params: undefined |  ListTopicMessagesV1TopicsTopicIdMessagesGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTopicMessagesV1TopicsTopicIdMessagesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTopicMessagesV1TopicsTopicIdMessagesGet>>,
          TError,
          Awaited<ReturnType<typeof listTopicMessagesV1TopicsTopicIdMessagesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTopicMessagesV1TopicsTopicIdMessagesGet<TData = Awaited<ReturnType<typeof listTopicMessagesV1TopicsTopicIdMessagesGet>>, TError = HTTPValidationError>(
 topicId: string,
    params?: ListTopicMessagesV1TopicsTopicIdMessagesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTopicMessagesV1TopicsTopicIdMessagesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTopicMessagesV1TopicsTopicIdMessagesGet>>,
          TError,
          Awaited<ReturnType<typeof listTopicMessagesV1TopicsTopicIdMessagesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTopicMessagesV1TopicsTopicIdMessagesGet<TData = Awaited<ReturnType<typeof listTopicMessagesV1TopicsTopicIdMessagesGet>>, TError = HTTPValidationError>(
 topicId: string,
    params?: ListTopicMessagesV1TopicsTopicIdMessagesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTopicMessagesV1TopicsTopicIdMessagesGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Topic Messages
 */

export function useListTopicMessagesV1TopicsTopicIdMessagesGet<TData = Awaited<ReturnType<typeof listTopicMessagesV1TopicsTopicIdMessagesGet>>, TError = HTTPValidationError>(
 topicId: string,
    params?: ListTopicMessagesV1TopicsTopicIdMessagesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTopicMessagesV1TopicsTopicIdMessagesGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTopicMessagesV1TopicsTopicIdMessagesGetQueryOptions(topicId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






